import React from 'react'

import ArrowLeft from '@icons/ArrowLeft'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type ScrollToTopProps = {
  showOnPc?: boolean
}

const ScrollToTop: React.FC<ScrollToTopProps> = ({ showOnPc = false }) => {
  const { t } = useTranslation()

  return (
    <button
      className={style.scroll}
      data-show={showOnPc}
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }}
    >
      <ArrowLeft />
      <div className={style.text}>{t('artisan.toTop')}</div>
    </button>
  )
}

export default ScrollToTop
